var _circle, _circle2, _circle3, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmojiEmbrassed = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 64,
  height: 64,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 32,
  r: 26.667,
  fill: "#FFDC75"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 25.334,
  cy: 25.333,
  r: 4,
  fill: "#2D384E"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 38.667,
  cy: 25.333,
  r: 4,
  fill: "#2D384E"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 21.334,
  y: 32,
  width: 21.333,
  height: 2.667,
  rx: 1,
  fill: "#FF8E1C"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M56 17.646C56 21.157 53.614 24 50.667 24c-2.948 0-5.334-2.843-5.334-6.354 0-3.512 5.334-12.313 5.334-12.313S56 14.134 56 17.646Z",
  fill: "#2D91FF",
  stroke: "#2D91FF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgEmojiEmbrassed;